module.exports = __webpack_public_path__ + "static/img/JOEL-FREIJAH.77a84c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/JOEL-FREIJAH.jpg
// module id = NGkI
// module chunks = 0